import {
  CREATE_CURVE_SUCCESS,
  GET_ALL_CURVES_SUCCESS,
  DELETE_CURVE_SUCCESS,
  SET_CURVES_SUCCESS,
  SET_INDIVIDUAL_CURVE_SUCCESS
} from './actions';

const initialState = {
  curves: []
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ALL_CURVES_SUCCESS:
    case SET_CURVES_SUCCESS:
    case SET_INDIVIDUAL_CURVE_SUCCESS:
      return {
        ...state,
        curves: action.data
      };
    case CREATE_CURVE_SUCCESS:
    case DELETE_CURVE_SUCCESS:
      return {
        ...state,
        curves: action.data
      };
    default:
      return state;
  }
};

export default reducer;
